import { useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useStoreUnitActions } from 'src/redux/helpers';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { API_SOLUTION_PUT_ADX_TABLES } from '../../constants';
import solutionsStore from '../../redux';
import { SolutionAdxTablesItem } from '../../types';
import SolutionAdxTableEditModal from './SolutionAdxTableEditModal';

type Props = {
  item: SolutionAdxTablesItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionAdxTableCreateContainer({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generateApiPath(API_SOLUTION_PUT_ADX_TABLES, {
          solutionId,
          id: item?.tableName,
        }),
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'ADX Table saved',
        text: `${item.tableName} ADX Table has been modified successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.adxMappedTables(solutionId);
    }
  );

  return (
    <SolutionAdxTableEditModal
      item={item}
      title="Edit ADX Table"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
}

export default SolutionAdxTableCreateContainer;
